import { Formik, Form as FormikForm } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Back } from ".";
import Loader from "../components/Loader";
import { useEffect } from "react";
import { mainApi } from "../providers/api";
import { confirmPopup, successAlert, translateError } from "../providers/alert";
import { useState } from "react";
import {
  RiCheckLine,
  RiCloseLine,
  RiDeleteBin2Fill,
  RiEdit2Fill,
} from "react-icons/ri";
import objectPath from "object-path";

const Form = ({
  id,
  editable,
  children,
  model,
  init,
  success,
  validationSchema,
  beforeSubmit,
  containerClass = "",
  view,
  isDeletable,
  back,
  text,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(id);
  const [submited, setSubmited] = useState();
  const [initialValues, setInitialValues] = useState(init);
  console.log("🚀 ~ initialValues:", initialValues);

  const formik = {
    enableReinitialize: true,
    initialValues: init,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        console.log("ddddd");

        let data = beforeSubmit ? await beforeSubmit(values) : values;

        const response = await mainApi({
          url: `/${model}/${id ?? ""}`,
          method: id ? "PUT" : "POST",
          data,
        });

        setSubmitting(false);

        if (response) {
          setSubmited(new Date());

          if (success) {
            setDisabled(true);
            success && success({ response: response.data });
          } else {
            navigate(-1);
            successAlert();
          }
        }
      } catch (error) {
        translateError(error);
      }
    },
  };

  return (
    <div className="relative">
      <Formik {...formik}>
        {({ isSubmitting, values, errors, ...rest }) => {
          const isLoading = loading || isSubmitting;

          return (
            <FormikForm className={` ${containerClass}`} autoComplete="off">
              {isLoading && <Loader size={500} />}

              {disabled && view
                ? view(values)
                : children &&
                  children({
                    loading: isLoading,
                    submited,
                    values,
                    id,
                    disabled,
                    t,
                    errors: errors,
                    form: rest,
                  })}
            </FormikForm>
          );
        }}
      </Formik>
    </div>
  );
};

export default Form;
